import { createReducer } from "typesafe-actions";
import * as ac from "./action-creators";
import INITIAL_PROFILES_STATE from "./initial-state";
import type { ProfilesActionsType, ProfilesStateType } from "../types/state";

const profilesReducer = createReducer<ProfilesStateType, ProfilesActionsType>(INITIAL_PROFILES_STATE)
    .handleAction(
        ac.profilesResultsClearedAction,
        (state): ProfilesStateType => ({
            ...state,
            profilesResult: INITIAL_PROFILES_STATE.profilesResult,
        }),
    )
    .handleAction(
        ac.resetCreatedProfileAction,
        (state): ProfilesStateType => ({
            ...state,
            createdProfile: undefined,
        }),
    )
    .handleAction(
        ac.fetchProfilesAsync.request,
        (state): ProfilesStateType => ({
            ...state,
            areProfilesFetching: true,
            profilesFetchError: INITIAL_PROFILES_STATE.profilesFetchError,
        }),
    )
    .handleAction(
        ac.fetchProfilesAsync.success,
        (state, { payload }): ProfilesStateType => ({
            ...state,
            profilesResult: payload,
            areProfilesFetching: false,
        }),
    )
    .handleAction(
        ac.fetchProfilesAsync.failure,
        (state, { payload }): ProfilesStateType => ({
            ...state,
            areProfilesFetching: false,
            profilesFetchError: payload,
        }),
    )
    .handleAction(
        ac.createProfileAsync.request,
        (state): ProfilesStateType => ({
            ...state,
            isProfileCreating: true,
            profileCreateError: INITIAL_PROFILES_STATE.profileCreateError,
        }),
    )
    .handleAction(
        ac.createProfileAsync.success,
        (state, { payload }): ProfilesStateType => ({
            ...state,
            isProfileCreating: false,
            createdProfile: payload,
            profilesResult: {
                profiles: state.profilesResult.profiles.concat(payload),
                totalCount: state.profilesResult.totalCount + 1,
            },
        }),
    )
    .handleAction(
        ac.createProfileAsync.failure,
        (state, { payload }): ProfilesStateType => ({
            ...state,
            isProfileCreating: false,
            profileCreateError: payload,
        }),
    )
    .handleAction(
        ac.updateProfileAsync.request,
        (state): ProfilesStateType => ({
            ...state,
            isProfileUpdating: true,
            profileUpdateError: INITIAL_PROFILES_STATE.profileUpdateError,
        }),
    )
    .handleAction(
        ac.updateProfileAsync.success,
        (state, { payload }): ProfilesStateType => ({
            ...state,
            isProfileUpdating: false,
            profilesResult: {
                ...state.profilesResult,
                profiles: state.profilesResult.profiles.map((profile) => {
                    if (profile.id === payload.id) {
                        return payload;
                    }

                    return profile;
                }),
            },
        }),
    )
    .handleAction(
        ac.updateProfileAsync.failure,
        (state, { payload }): ProfilesStateType => ({
            ...state,
            isProfileUpdating: false,
            profileUpdateError: payload,
        }),
    )
    .handleAction(
        ac.deleteProfileAsync.request,
        (state): ProfilesStateType => ({
            ...state,
            isProfileDeleting: true,
            profileDeleteError: INITIAL_PROFILES_STATE.profileDeleteError,
        }),
    )
    .handleAction(
        ac.deleteProfileAsync.success,
        (state, { payload }): ProfilesStateType => ({
            ...state,
            isProfileDeleting: false,
            profilesResult: {
                profiles: state.profilesResult.profiles.filter((profile) => {
                    return profile.id !== payload;
                }),
                totalCount: state.profilesResult.totalCount - 1,
            },
        }),
    )
    .handleAction(
        ac.deleteProfileAsync.failure,
        (state, { payload }): ProfilesStateType => ({
            ...state,
            isProfileDeleting: false,
            profileDeleteError: payload,
        }),
    )
    .handleAction(
        ac.excludeProfileAsync.request,
        (state): ProfilesStateType => ({
            ...state,
            isProfileExcluding: true,
            profileExcludeError: INITIAL_PROFILES_STATE.profileExcludeError,
        }),
    )
    .handleAction(
        ac.excludeProfileAsync.success,
        (state, { payload }): ProfilesStateType => ({
            ...state,
            isProfileExcluding: false,
            profilesResult: {
                profiles: state.profilesResult.profiles.filter((profile) => {
                    return profile.id !== payload;
                }),
                totalCount: state.profilesResult.totalCount - 1,
            },
        }),
    )
    .handleAction(
        ac.excludeProfileAsync.failure,
        (state, { payload }): ProfilesStateType => ({
            ...state,
            isProfileDeleting: false,
            profileDeleteError: payload,
        }),
    );

export default profilesReducer;
